(function() {

    let app = angular.module('TetherApp');

    let AssetController = function (
        $window,
        campaignService,
        marketingChannelService,
        marketingPlacementService,
        marketingPlacementDetailService
    ) {
        let self = this;
		self.clientId;
		self.campaignId;
		self.marketingChannelId;
        self.marketingChannels = {};
        self.marketingChannelName = '';
        self.marketingPlacementId;
        self.marketingPlacements = {};
        self.marketingPlacementName = '';
		self.marketingPlacementDetailId;
        self.marketingPlacementDetails = {};
        self.marketingPlacementDetailName = '';

        self.init = function () {
			self.listCampaigns();
			self.listMarketingChannels();
			self.listMarketingPlacements();
			self.listMarketingPlacementDetails();
        };

		self.onAnyDropdownChange = function() {
			if(!self.marketingChannelId)
			{
				self.marketingPlacementId = '';

			}

			if(!self.marketingPlacementId)
			{
				self.marketingPlacementDetailId = '';
			}
		};

		self.listCampaigns = function()
		{
			campaignService.list()
				.then(onCampaignList, onError);
		};

		let onCampaignList = function(data){
			self.campaigns = data;
		}

		self.listMarketingChannels = function()
		{
			marketingChannelService.list()
				.then(onMarketingChannelList, onError);
		};

		let onMarketingChannelList = function(data){
			self.marketingChannels = data;
		}

		self.createMarketingChannel = function()
		{
			marketingChannelService.create(self.marketingChannelName)
				.then(onMarketingChannelCreate, onError);
		};

        let onMarketingChannelCreate = function (data) {
        	self.marketingChannelName = '';
            self.listMarketingChannels();
        };

		self.listMarketingPlacements = function()
		{
			if(self.marketingChannelId){
				marketingPlacementService.list(self.marketingChannelId)
					.then(onMarketingPlacementList, onError);
			}
		};

		let onMarketingPlacementList = function(data){
			self.marketingPlacements = data;
		}

		self.createMarketingPlacement = function()
		{
			marketingPlacementService.create(self.marketingPlacementName, self.marketingChannelId)
				.then(onMarketingPlacementCreate, onError);
		};

        let onMarketingPlacementCreate = function (data) {
        	self.marketingPlacementName = '';
            self.listMarketingPlacements();
        };

		self.listMarketingPlacementDetails = function()
		{
			if(self.marketingPlacementId && self.campaignId){
				marketingPlacementDetailService.list(self.marketingPlacementId, self.campaignId)
					.then(onMarketingPlacementDetailList, onError);
			}
		};

		let onMarketingPlacementDetailList = function(data){
			self.marketingPlacementDetails = data;
		}

		self.createMarketingPlacementDetail = function()
		{
			marketingPlacementDetailService.create(
				self.marketingPlacementDetailName,
				self.marketingPlacementId,
				self.campaignId
			)
				.then(onMarketingPlacementDetailCreate, onError);
		};

        let onMarketingPlacementDetailCreate = function (data) {
        	self.marketingPlacementDetailName = '';
            self.listMarketingPlacementDetails();
        };

        let onError = function(reason) {
            // console.log('Error occurred while deleting keyword');
        };
    };

    angular.module('TetherApp').controller('AssetController', [
        '$window',
        'campaignService',
        'marketingChannelService',
        'marketingPlacementService',
        'marketingPlacementDetailService',
        AssetController
    ]);
}());
